/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window',
    'pip-common.utils'
],
function(
    pip,
    pipEvents,
    window,
    pipCommonUtils
){
    var contentModule = {
        name:'buy box',
        feature: 'plcc',
        type: 'cta'
    };
    var DISPLAY_PRICE_THRESHOLD = 299;
	function initEventListeners() {
        pipEvents.consumerCreditMessage.applyNowClicked.off();
		pipEvents.consumerCreditMessage.applyNowClicked.on(function(){
            var obj ={
                category:{
                    primaryCategory: 'button submission'
                },
                eventInfo: {
                    eventName: 'content module interaction'
                },
                content: {
                    module: [contentModule]
                }
            };
            if(window.digitalData && window.digitalData.event) window.digitalData.event.push(obj);
        });
	}
    function postDisplayCreditMessage() {
        if(window.digitalData && window.digitalData.content && window.digitalData.content.module){
            if(shouldDisplayPaymentEstimator()) {
                contentModule.feature = 'plcc-est';
            }
            window.digitalData.content.module.push(contentModule);
        }
    }
    function shouldDisplayPaymentEstimator() {
        var displayPrice = pipCommonUtils.deepGet(pip,'products.primary.data.itemExtension.displayPrice');
        return (pip.features.paymentEstimatorEnabled && displayPrice >= DISPLAY_PRICE_THRESHOLD);
    }
	return {
		init: function(){
            var isDiscontinuedItem = pipCommonUtils.deepGet(pip,'products.primary.data.itemAvailability.discontinuedItem');
            if(!isDiscontinuedItem && pip.features.consumerCreditMessageEnabled) {
                postDisplayCreditMessage();
                initEventListeners();
            }
		}
	}

});

}.call(window));